import angular from 'angular';
import 'ui-select';
import 'ng-flow';
import 'angular-bootstrap';
import 'ng-file-upload';
import './productsDirectives';
import './productsServices';

const productsControllers = angular.module('applicationModule.productsControllers', [
    'applicationModule.productsDirectives',
    'applicationModule.productsServices',
    'flow',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select'
]);
// Products Controllers
productsControllers.controller('ProductsListController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'Product', 'growl', '$filter', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $state, $stateParams, NgTableParams, Product, growl, $filter, AppsoupAPI, Permissions, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('products');
    $scope.application_id = $stateParams.application_id;
    $scope.isLoading = false;
    $scope.isLoadingExport = false;
    $scope.showImage = {};
    $scope.check = false;
    $scope.search = {};
    $scope.checkedProducts = [];
    $scope.editProductsMode = false;
    $scope.searchItem = null;
    $scope.massive = {};
    $scope.exports = {};
    $scope.package_id = null;
    var refresh = true;
    $scope.productTypes = [{
        text: 'MODULES.COUPONS.LABEL.GLOBAL',
        value: 'global'
    }, {text: 'MODULES.COUPONS.LABEL.LOCAL', value: 'local'}];
    $scope.massive.application_id = $scope.application_id;
    $scope.massiveActions = [
        {key: 'EDIT', value: 'MODULES.PRODUCTS.BTN.EDIT'},
        {key: 'DELETE', value: 'MODULES.PRODUCTS.BTN.DELETE'},
        {key: 'PUBLISH', value: 'BUTTONS.PUBLISH'}
    ];
    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams('title'), {
        getData: function (params) {
            $scope.isLoading = true;
            return Product.getList($scope.application_id, params._params)
                .then(function (response) {
                    $scope.categories = response.categories;
                    params.total(response.product.total);
                    params.count(response.product.per_page);
                    params.page(response.product.current_page);

                    $scope.package_id = response.packageId;
                    $scope.allStatuses = response.allStatuses;
                    $scope.canEditShopId = response.canEditShopId;
                    if (angular.isDefinedNotNull($stateParams.searchProduct)) {
                        $scope.search = $stateParams.searchProduct;
                        $scope.searchProducts($scope.search);
                    }

                    return response.product.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.checkImage = function (index, src) {
        Product.isImage(src).then(function (result) {
            if (result) {
                $scope.showImage[index] = true;
            }
        });

    };

    $scope.selectProduct = function (id) {
        $scope.checkedProducts = angular.selectElement($scope.checkedProducts, id);

        if ($scope.checkedProducts.length < 1) {
            $scope.clearAction();
        }
    };

    $scope.selectAllProducts = function (item) {
        $scope.checkedProducts = angular.selectAllElements($scope.checkedProducts, item);
    };
    $scope.checkSelectedProducts = function (item) {
        return angular.checkSelectedElements($scope.checkedProducts, item);
    };
    $scope.editProducts = function () {
        $scope.editProductsMode = true;
    };

    function refreshData() {
        $scope.searchProducts({refresh: refresh});
        refresh = !refresh;
        $scope.checkedProducts = [];
    }

    $scope.publishProducts = function () {
        Product.publish($scope.application_id, $scope.checkedProducts).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.COUPONS.SUCCESS.PUBLISHED');
            } else {
                growl.error('MODULES.COUPONS.ERROR.PUBLISHED');
            }
        }).catch(function () {
            growl.error('MODULES.COUPONS.ERROR.PUBLISHED');
        }).finally(function () {
            $scope.editProductsMode = false;
            refreshData();
        });
    };
    $scope.massiveActionCategory = function (toAdd) {
        $scope.massive.toAdd = toAdd;
        $scope.massive.checkedProducts = $scope.checkedProducts;
        if ($scope.massive.categories) {
            $scope.isLoadingMassive = true;
            Product.massiveActionCategory($scope.massive).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PRODUCTS.SUCCESS.' + (toAdd ? 'ADD_CATEGORIES' : 'DELETE_CATEGORIES'));
                    $state.reload();
                } else {
                    growl.error('MODULES.PRODUCTS.ERROR.' + (toAdd ? 'ADD_CATEGORIES' : 'DELETE_CATEGORIES'));
                }
            }).finally(function () {
                $scope.clearAction();
                $scope.isLoadingMassive = false;
            });

        } else {
            growl.error('MODULES.PRODUCTS.ERROR.NO_CHECKED_CATEGORIES');
        }
    };
    $scope.clearAction = function () {
        $scope.massive = {};
        $scope.massive.application_id = $scope.application_id;
        $scope.editProductsMode = false;
        $scope.searchedCategories = [];
    };
    $scope.changeCategories = function () {
        if (angular.isDefined($scope.massive.categories)) {
            var tempTags = [];
            angular.forEach($scope.massive.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.massive.categories = tempTags;
        }
    };
    $scope.removeProduct = function (id, index) {
        Product.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PRODUCTS.SUCCESS.DELETE_PRODUCT');
                    $scope.tableParams.data.splice(index, 1);
                    var productId = $scope.checkedProducts.indexOf(id);
                    if (productId >= 0) {
                        $scope.checkedProducts.splice(productId, 1);
                        if ($scope.checkedProducts.length < 1) {
                            $scope.clearAction();
                        }
                    }
                } else {
                    growl.error('MODULES.PRODUCTS.ERROR.DELETE');
                }
            });
    };
    $scope.removeProducts = function () {
        angular.forEach($scope.checkedProducts, function (val) {
            angular.forEach($scope.tableParams.data, function (v, k) {
                if (val === v.id) {
                    $scope.tableParams.data.splice(k, 1);
                }
            });
        });
        Product.removeChecked($scope.checkedProducts, $scope.application_id).then(function (result) {
            let data = result.data;

            if (!data.success) {
                growl.error('MODULES.PRODUCTS.ERROR.DELETE_PRODUCTS');
            }
        });
        growl.success('MODULES.PRODUCTS.SUCCESS.DELETE_PRODUCTS');
        $scope.checkedProducts = [];
    };
    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        Product.categories($scope.application_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.searchedCategories = data.categories;
            }
        });
    };
    $scope.searchedCategories = [];
    $scope.searchProducts = function (search) {
        if ($scope.productsFind.$valid) {
            $scope.isFind = true;
            var find = angular.copy(search);
            angular.extend($scope.tableParams._params, find);
            $scope.searchItem = $scope.search;
            $scope.isFind = false;
        }
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.category)) {
            $scope.tableParams._params.category = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.price_from)) {
            $scope.tableParams._params.price_from = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.price_to)) {
            $scope.tableParams._params.price_to = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.retail_from)) {
            $scope.tableParams._params.retail_from = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.retail_to)) {
            $scope.tableParams._params.retail_to = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.sap_id)) {
            $scope.tableParams._params.sap_id = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.status_label)) {
            $scope.tableParams._params.status_label = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type_product)) {
            $scope.tableParams._params.type_product = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type_product_ids)) {
            $scope.tableParams._params.type_product_ids = undefined;
        }

        $stateParams.searchProduct = null;
        $scope.searchItem = null;
    };
    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

    $scope.editModalProduct = function (product, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/products/components/modal/product.tpl.html',
            controller: 'ProductModalController',
            backdrop: 'static',
            resolve: {
                product: function () {
                    return product;
                }
            }
        });

        modalInstance.result.then(function (data) {
            $scope.tableParams.data[index] = data;
            growl.success('MODULES.PRODUCTS.SUCCESS.EDIT_PRODUCT');
        }).catch(() => {});
    };

    $scope.getProductImage = function (product) {
        if (angular.isDefined(product.ean)) {
            Product.getImage(product.id, product.ean)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('GROWL.SUCCESS.DOWNLOAD.IMAGE');
                    } else {
                        growl.error('GROWL.ERROR.DOWNLOAD.IMAGE');
                    }
                });
        }
    };

    $scope.generateCsv = function (appId) {
        $scope.isLoadingExport = true;
        if ($scope.isLoading) {
            growl.info('GROWL.INFO.EXPORT');
        }
        Product.generateCSV(appId, $scope.exports.hours)
            .then(function (result) {
                let data = result.data;

                if (data.error) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                    growl.success('GROWL.SUCCESS.EXPORT');
                }
            }).finally(function () {
            $scope.isLoading = false;
            $scope.isLoadingExport = false;
        });
    };
    $scope.searchShops = function (text) {
        if (text) {
            Product.searchShop($scope.application_id, text).then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.shop_ids = data.shopIds;
                }
            });
        }
    };
}]);
productsControllers.controller('ProductPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'App', 'Product', '$filter', '$q', function ($scope, $rootScope, $state, $stateParams, growl, App, Product, $filter, $q) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.product = {};
    var publishedInactive = 3;
    $scope.product = {
        application_id: $stateParams.application_id,
        status: '1',
        attributes: {},
        categories: [],
        published: publishedInactive
    };

    $scope.editMode = false;
    $scope.categories = [];
    $scope.promotions = [];
    $scope.moduleAttributes = {};
    $scope.attributesExists = 0;
    $scope.isLoading = true;
    $scope.package_id = null;

    var productId = $stateParams.productId;
    var attributeType = 'product';

    var qAll = [];
    if (productId) {
        qAll.push(
            Product.get(productId, $scope.product.application_id).then(getProducts).catch(onErrorProducts).finally(Product.getAttribute($scope.product.application_id, attributeType).then(getAttributes).finally(setAttributes)),
            Product.getPromotions(productId).then(getPromotions)
        );
        $scope.editMode = true;
    } else {
        qAll = [Product.getAttribute($scope.product.application_id, attributeType).then(getAttributes).finally(setAttributes)];
    }
    Product.getStatusLabels($scope.product.application_id).then(function (result) {
        let data = result.data;

        if (data.success) {
            $scope.canEditShopId = data.canEditShopId;
            $scope.userExternalId = data.userExternalId;
            $scope.statusLabels = data.statusLabels;
            $scope.allStatuses = data.allStatuses;
            if (!productId && !data.canEditShopId && $scope.userExternalId) {
                $scope.product.shop_id = [$scope.userExternalId];
            }
        }
    });

    $scope.searchShops = function (text) {
        if (text) {
            Product.searchShop($scope.product.application_id, text).then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.shop_ids = data.shopIds;
                }
            });
        }
    };

    function setAttributes() {
        angular.forEach($scope.moduleAttributes, function (attribute, key) {
            if (!$scope.product.attributes[key] && $scope.moduleAttributes[key].default) {
                $scope.product.attributes[key] = $scope.moduleAttributes[key].default;
            }
        });
    }

    $q.all(qAll)
        .finally(function () {
            $scope.isLoading = false;
        });

    function getAttributes(data) {
        if (data.success) {
            $scope.moduleAttributes = data.attributes;
            $scope.attributesExists = Object.keys($scope.moduleAttributes).length;
            $scope.package_id = data.package_id;
        } else {
            growl.error('MODULES.PRODUCTS.' + data.error);
        }
    }

    function getProducts(data) {
        if (data.success) {
            $scope.product = data.product;
            $scope.namep = data.product.title;

            angular.forEach($scope.moduleAttributes, function (attribute, key) {
                if (!$scope.product.attributes[key] && $scope.moduleAttributes[key].default) {
                    $scope.product.attributes[key] = $scope.moduleAttributes[key].default;
                }
            });
        } else {
            growl.error('MODULES.PRODUCTS.' + data.error);
        }
    }

    function onErrorProducts() {
        $state.go('appsoup.application.products', {searchProduct: $stateParams.searchProduct});
        growl.error('ERROR.EMPTY_DATA');
    }

    function getPromotions(data) {
        if (data.success) {
            $scope.promotions = data.promotions;
        }
    }

    $scope.showElement = function (value) {
        return (angular.isDefined(value) && value);
    };

    $scope.categoryChange = function () {
        $scope.errorCategory = ($scope.product.categories.length === 0);
    };

    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        Product.categories($scope.product.application_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.categories = data.categories;
            }
        });
    };
    $scope.categories = [];

    $scope.changeCategories = function () {
        if (angular.isDefined($scope.product.categories)) {
            var tempTags = [];
            angular.forEach($scope.product.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.product.categories = tempTags;
            $scope.errorCategory = ($scope.product.categories.length === 0);
        }
    };

    $scope.changeToFloat = function (key, value) {
        $scope.product.attributes[key] = Number(parseFloat(value).toFixed(2));
    };

    $scope.saveProduct = function () {
        $scope.$broadcast('show-errors-check-validity');

        $scope.changeCategories();

        if ($scope.productForm.$valid) {
            $scope.isLoading = true;
            if (angular.isDefined(productId)) {
                $scope.product.id = productId;
            }

            Product.save($scope.product, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.PRODUCTS.SUCCESS.' + ($scope.editMode ? 'EDIT_PRODUCT' : 'NEW_PRODUCT'));
                        $state.go('appsoup.application.products', {searchProduct: $stateParams.searchProduct});
                    } else {
                        if (angular.isDefined(data.error.file)) {
                            $scope.errorDimenssions = true;
                        }
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.PRODUCTS.ERROR.CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };
    $scope.cancel = function () {
        $state.go('appsoup.application.products', {searchProduct: $stateParams.searchProduct});
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'categories': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'price': [{error: 'pattern', msg: 'FORM.ERRORS.FORMAT'}],
        'retail_price': [{error: 'pattern', msg: 'FORM.ERRORS.FORMAT'}],
        'order_id': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'review_score': [{error: 'pattern', msg: 'FORM.ERRORS.FORMAT'}]
    };
}]);

productsControllers.controller('ProductModalController', ['$scope', '$modalInstance', 'growl', 'Product', 'product', '$filter', function ($scope, $modalInstance, growl, Product, product, $filter) {
    'use strict';

    $scope.product = {};
    $scope.editMode = true;

    Product.get(product.id, product.application_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.product = data.product;
            } else {
                growl.error('MODULES.PRODUCTS.' + data.error);
            }
        });

    $scope.categoryChange = function () {
        $scope.errorCategory = ($scope.product.categories.length === 0);
    };
    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        Product.categories(product.application_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.categories = data.categories;
            }
        });
    };

    $scope.categories = [];

    $scope.changeCategories = function () {
        if (angular.isDefined($scope.product.categories)) {
            var tempTags = [];
            angular.forEach($scope.product.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.product.categories = tempTags;
        }
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        if (angular.isDefined($scope.product.categories)) {
            var tags = [];

            angular.forEach($scope.product.categories, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value)) {
                    tags.push(value);
                }
            });

            $scope.product.categories = tags;
        }

        Product.save($scope.product, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $modalInstance.close(data.product);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.PRODUCTS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'MODULES.PRODUCTS.ERROR.REQUIRE.TITLE'}],
        'order_id': [{error: 'pattern', msg: 'MODULES.PRODUCTS.FORM_ERROR.ORDER'}]
    };
}]);

productsControllers.controller('ProductImportController', ['$scope', '$rootScope', '$stateParams', '$state', 'Product', 'growl', '$translate', function ($scope, $rootScope, $stateParams, $state, Product, growl, $translate) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;
    $scope.productsNotAdded = [];
    $scope.mergeType = 'title';
    var attributeType = 'product';

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
        $scope.productsNotAdded = [];
    };
    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };
    $scope.cancel = function () {
        $state.go('appsoup.application.products');
    };

    Product.getAttribute($scope.application_id, attributeType).then(function (result) {
        let data = result.data;

        if (data.success) {
            $scope.moduleAttributes = data.attributes;

            angular.forEach($scope.moduleAttributes, function (attribute, key) {
                if (attribute.required !== true) {
                    delete $scope.moduleAttributes[key];
                }
            });
            $scope.attributesNames = Object.keys($scope.moduleAttributes);
        } else {
            growl.error('MODULES.PRODUCTS.' + data.error);
        }
    });

    $scope.saveFile = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.productImportForm.$valid) {
            $scope.isLoading = true;
            Product.importProducts($scope.application_id, $scope.upload, $scope.mergeType).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PRODUCTS.SUCCESS.IMPORT_PRODUCT');
                    $state.go('appsoup.application.products');
                } else {
                    if (data.error.length > 0) {
                        $scope.productsNotAdded = data.productsNotAdded;

                        var transError = 'MODULES.PRODUCTS.IMPORT.ERRORS.' + data.error;
                        $translate(transError).then(function () {
                        }, function () {
                            transError = 'MODULES.PRODUCTS.IMPORT.ERRORS.UNDEFINED';
                        }).finally(function () {
                            growl.error(transError);
                        });
                    } else {
                        growl.error('MODULES.PRODUCTS.ERROR.IMPORT');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.$watchGroup(['mergeType', 'attributesNames'], function () {
        $scope.requiredFields = [];
        $scope.requiredFields.push('title');
        if ($scope.mergeType && $scope.requiredFields.indexOf($scope.mergeType) === -1) {
            $scope.requiredFields.push($scope.mergeType);
        }
        if ($scope.attributesNames && $scope.attributesNames.length) {
            $scope.requiredFields.push($scope.attributesNames);
        }

        $scope.requiredFields = $scope.requiredFields.map(function (rf) {
            return '"' + rf + '"';
        });
    });
}]);
productsControllers.controller('ProductGalleryController', ['$scope', '$rootScope', '$stateParams', 'ProductGallery', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, ProductGallery, growl, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('products');
    $scope.application_id = $stateParams.application_id;
    $scope.product_id = $stateParams.productId;
    var token = localStorage.getItem('appsoup:userToken');
    ProductGallery.get($scope.product_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.files = data.gallery;
            } else {
                growl.error('MODULES.PRODUCTS.' + data.error);
            }
        })
        .finally(function () {
            $rootScope.doingResolve = false;
        });
    $scope.flowInit = {
        target: '/api/app/product/gallery/upload/' + $scope.product_id + '/' + $scope.application_id,
        testChunks: false,
        chunkSize: 1024 * 1024,
        forceChunkSize: true,
        headers: {
            'Authorization': 'Bearer ' + token.toString()
        }
    };
    $scope.fileSuccess = function (file, messageStr) {
        var message = angular.fromJson(messageStr);
        file.id = message.id;
    };

    $scope.deleteImage = function (file) {
        ProductGallery.remove($scope.product_id, $scope.application_id, file.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    if (file.backend) {
                        delete $scope.files[file.id];
                    }
                } else {
                    growl.error('MODULES.PRODUCTS.' + data.error);
                }
            });
    };
}]);

export default productsControllers;
